import React, { useState, useRef, useEffect } from 'react';
import { ApiCore } from '../../api/index';
import { Toast } from 'antd-mobile';
import available_point from '../../static/images_ae/pointsMall/available_point.png';
import daily_share from '../../static/images_ae/pointsMall/daily_share.png';
import daily_test_task from '../../static/images_ae/pointsMall/daily_test_task.png';
import evalution_report from '../../static/images_ae/pointsMall/evalution_report.png';
import point_icon from '../../static/images_ae/pointsMall/point_icon.png';
import point_level from '../../static/images_ae/pointsMall/point_level.png';
import read_ae_article from '../../static/images_ae/pointsMall/read_ae_article.png';
import task_calendar from '../../static/images_ae/pointsMall/task_calendar.png';
import upload_avatar from '../../static/images_ae/pointsMall/upload_avatar.png';
import complete_personal_info from '../../static/images_ae/pointsMall/complete_personal_info.png';
import ae_auto_evaluation from '../../static/images_ae/pointsMall/ae_auto_evaluation.png';
import vip_bg_card from '../../static/images_ae/pointsMall/vip_bg_card_blue.png'; // vip_bg_card
import { withRouter } from 'react-router-dom';
import styles from './index.module.scss';
import utils from '../../utils/utils';

const api = new ApiCore();

const AePointsMall = (props: any) => {

    const savedUrlParam = localStorage.getItem('OriginUrlParam') || null;
    const shoppingParams = JSON.parse(JSON.parse(savedUrlParam)?.data || null) || ''
    const [freshmanTask, setFreshmanTask] = useState([]);
    const [weekTask, setWeekTask] = useState([]);
    const [dayTask, setDayTask] = useState([]);
    const [pointCount, setPointCount] = useState<any>(null);
    const [isGuest, setIsGuest] = useState<any>(null);

    useEffect(() => {
        window.document.title = '积分商城';
        initCondition();
        initData();
        // 微信返回更新完善信息
        initEvent();
        return () => {
            document.removeEventListener('visibilitychange', refreshTaskList);
        }
    }, [])

    const initCondition = () => {
        if(Number(shoppingParams.type) === 3) {
            setIsGuest(true)
        } else {
            setIsGuest(false)
        }
    }

    const initData = () => {
        api.getAeTaskList({}).then((res: any) => {
            if (res.code == 0) {
                const _data = res.data || [];
                let _novice: any = [];
                let _week: any = [];
                let _day: any = [];
                _data.forEach((val: any) => {
                    if (val.type == 'week') {
                        _week.push(val);
                    } else if (val.type == 'day') {
                        _day.push(val);
                    } else if (val.type == 'novice') {
                        _novice.push(val);
                    }
                });
                setWeekTask(_week);
                setDayTask(_day);
                setFreshmanTask(_novice);
            }
        });
        api.toGetAeAllCount().then((res: any) => {
            if (res.code == 0) {
                setPointCount(res.data);
            }
        })
    }

    const initEvent = () => {
        document.addEventListener('visibilitychange', refreshTaskList);
    }

    const refreshTaskList = () => {
        if (!document.hidden) {
            initData();
        }
    }

    const toComplete = (val: any) => {
        if(checkAuthor()) return
        // 完成任务领取奖励
        if (val.state == 2) {
            api.toGetAeTaskClaim({
                code: val.code
            }).then((res: any) => {
                if (res.code == 0) {
                    Toast.show('领取成功', 1);
                    initData();
                } else {
                    Toast.show(res.message || '领取失败', 1);
                }
            });
        } else if (val.state != 3) {
            // 去完成任务
            const _path = val.path;
            // 跳转微信小程序
            if (_path && _path.indexOf('/pages') === 0) {
                (window as any).wx.miniProgram.navigateTo({
                    url: _path,
                    success: function (e: any) {
                    },
                    fail: function (e: any) {
                    }
                })
            } else if(_path) {
                if (_path.indexOf('/ae/calendar') >= 0) {
                    let _toPath = _path;
                    if (_toPath.indexOf('?') >= 0) {
                        _toPath += '&needHomeInfo=true'
                    } else {
                        _toPath += '?needHomeInfo=true'
                    }
                    props.history.push(_toPath);
                } else if (_path.indexOf('/ae/home?tab=') == 0) {
                    const [_pre, _tab] = _path.split('/ae/home?tab=');
                    props.updateTab(_tab);
                } else if (_path) {
                    props.history.push(_path);
                }
            }
        }
    }

    const isPersoanNeedComplete = () => {
        return new Promise<any>((resolve, reject) => {
            api.getAePersonalInfo().then((res: any) => {
                if (res.code == 0) {
                    let _data = res.data || {};
                    if (Object.keys(_data).length === 0) {
                        resolve(true);
                    } else {
                        resolve(false);
                    }
                }
            })
        })
    }

    const freshmanImgRender = (val: any) => {
        if (val.name.indexOf('完成补充信息') >= 0) {
            return complete_personal_info;
        } else if (val.name.indexOf('授权手机号') >= 0) {
            return complete_personal_info;
        } else if (val.name.indexOf('完成一次AE上报') >= 0) {
            return ae_auto_evaluation;
        } else {
            return daily_share;
        }
    }

    const checkAuthor = () => {
        if(Number(shoppingParams.type) === 3) {
            (window as any).wx.miniProgram.navigateTo({url: `/pages/aeAuthor/aeAuthor`})
            return true
        }
    }
    // 前往商城
    const goShopping = () => {
        if(checkAuthor()) return
        const phone = shoppingParams.phone || '';
        const unionId = shoppingParams.unionId || '';
        (window as any).wx.miniProgram.navigateTo({url: `/pages/aeShopping/aeShopping?partyPhone=${phone}&partyUnionid=${unionId}`})
    }

    return (
        <div className={styles.ae_points_mall}>
            <div className={styles.head}>
                <img className={styles.img_bg} src={vip_bg_card} alt="" />
                <div className={styles.text_intro}>
                    <div className={styles.vip_level_current}>当前会员等级</div>
                    <div className={styles.vip_level_desc}>
                        <span className={styles.left_desc}>健康</span>
                        <span className={styles.right_desc}>会员</span>
                    </div>
                    <div className={styles.point_count_wrap}>
                        <div className={styles.number_progress}>
                            {/* <span className={styles.current}>2328</span> / 20000  */}
                            <span className={styles.current_point}>当前积分</span>
                        </div>
                        <div className={styles.point_count}>
                            {pointCount} 积分
                        </div>
                    </div>
                    <div className={styles.progress_bar_wrap}>
                        {/* <div className={styles.progress_bar_inner}>
                            <div className={styles.progress_bg} style={{width: (20 / 100) * 100 + '%'}}></div>
                        </div> */}
                    </div>
                </div>
            </div>

            <div className={styles.middle}>
                <div className={`${styles.middle_item_l}`}>
                    <div className={styles.middle_item_left}>
                        <img className={styles.point_img} src={point_icon} alt="" />
                    </div>
                    <div className={styles.middle_item_right}>
                        <div className={styles.middle_item_right_title}>我的积分</div>
                        <div className={styles.middle_item_right_desc}>{pointCount}</div>
                    </div>
                </div>
                <div className={`${styles.middle_item}  ${styles.middle_item_middle}`}>
                    <div className={`${styles.middle_item_left}`}>
                        <img className={styles.point_level} src={point_level} alt="" />
                    </div>
                    <div className={styles.middle_item_right}>
                        <div className={styles.middle_item_right_title}>积分等级</div>
                        <div className={styles.middle_item_point_level}>
                            健康会员
                        </div>
                    </div>
                </div>
                <div className={styles.middle_item}>
                    <div className={styles.middle_item_left}>
                        <img className={styles.available_point} src={available_point} alt="" />
                    </div>
                    <div className={styles.middle_item_right}>
                        <div className={styles.middle_item_right_title}>可用积分</div>
                        <div className={styles.middle_item_available_point}>
                            {pointCount}
                        </div>
                    </div>
                </div>
            </div>
            {/* <div className={styles.banner}>
            </div> */}
            <div className={styles.integralWrapper}>
                <h3 className={styles.title}>赚取积分</h3>
                {
                    isGuest == false &&
                    <div className={styles.goShopping} onClick={goShopping}>前往商城</div>
                }
            </div>
            <div className={styles.task}>
                <div className={styles.title}>
                    本周任务
                </div>
                {
                    weekTask && 
                    weekTask.map((val: any, key: number) => (
                        <div className={styles.task_item} key={key}>
                            <div className={styles.task_item_left}>
                                {/* <img src={task_calendar} alt="" /> */}
                                <img src={val.icon} alt="" />
                            </div>
                            <div className={`${styles.task_item_middle} ${(key + 1) != weekTask.length ? styles.task_item_bottom_line : ''}`}>
                                <div className={styles.task_item_middle_l}>
                                    <div className={styles.task_item_middle_top}>{val.name}</div>
                                    <div className={`${styles.task_item_middle_bottom}`}>
                                        <img src={point_icon} alt="" />
                                        <span>+{val.integral}</span>
                                    </div>
                                </div>
                                <div className={styles.task_item_right}>
                                    <div className={`${ val.state == 3 ? styles.completed_btn : styles.to_complete_btn}`} onClick={() => { toComplete(val)}}>
                                        {
                                            val.state == 3 ? 
                                            '已完成' :
                                            val.state == 2 ? 
                                            '领取奖励' :
                                            '去完成'
                                        }
                                    </div>
                                </div>
                            </div>
                        </div>
                    ))
                }
                {/* <div className={styles.task_item}>
                    <div className={styles.task_item_left}>
                        <img src={task_calendar} alt="" />
                    </div>
                    <div className={styles.task_item_middle}>
                        <div className={styles.task_item_middle_l}>
                            <div className={styles.task_item_middle_top}>连续签到3天</div>
                            <div className={styles.task_item_middle_bottom}>
                                <img src={point_icon} alt="" />
                                <span>+500</span>
                            </div>
                        </div>
                        <div className={styles.task_item_right}>
                            <div className={styles.to_complete_btn}>
                                去完成
                            </div>
                        </div>
                    </div>
                </div>
                <div className={styles.task_item}>
                    <div className={styles.task_item_left}>
                        <img src={task_calendar} alt="" />
                    </div>
                    <div className={styles.task_item_middle}>
                        <div className={styles.task_item_middle_l}>
                            <div className={styles.task_item_middle_top}>连续签到7天</div>
                            <div className={styles.task_item_middle_bottom}>
                                <img src={point_icon} alt="" />
                                <span>+150</span>
                            </div>
                        </div>
                        <div className={styles.task_item_right}>
                            <div className={styles.to_complete_btn}>
                                去完成
                            </div>
                        </div>
                    </div>
                </div> */}
            </div>
            
            {
                dayTask && dayTask.length > 0 && 
                <div className={styles.task}>
                    <div className={styles.title}>
                        日常任务
                    </div>
                    {
                        dayTask && 
                        dayTask.map((val: any, key: number) => (
                            <div className={styles.task_item} key={key}>
                                <div className={styles.task_item_left}>
                                    {/* <img src={task_calendar} alt="" /> */}
                                    <img src={val.icon} alt="" />
                                </div>
                                <div className={`${styles.task_item_middle} ${(key + 1) != weekTask.length ? styles.task_item_bottom_line : ''}`}>
                                    <div className={styles.task_item_middle_l}>
                                        <div className={styles.task_item_middle_top}>{val.name}</div>
                                        <div className={`${styles.task_item_middle_bottom}`}>
                                            <img src={point_icon} alt="" />
                                            <span>+{val.integral}</span>
                                        </div>
                                    </div>
                                    <div className={styles.task_item_right}>
                                        <div className={`${ val.state == 3 ? styles.completed_btn : styles.to_complete_btn}`} onClick={() => { toComplete(val)}}>
                                            {
                                                val.state == 3 ? 
                                                '已完成' :
                                                val.state == 2 ? 
                                                '领取奖励' :
                                                '去完成'
                                            }
                                        </div>
                                    </div>
                                </div>
                            </div>
                        ))
                    }
                </div>
            }
            {/* <div className={styles.task}>
                <div className={styles.title}>
                    新手任务
                </div>
                <div className={styles.task_item}>
                    <div className={styles.task_item_left}>
                        <img src={upload_avatar} alt="" />
                    </div>
                    <div className={styles.task_item_middle}>
                        <div className={styles.task_item_middle_l}>
                            <div className={styles.task_item_middle_top}>上传头像</div>
                            <div className={styles.task_item_middle_bottom}>
                                <img src={point_icon} alt="" />
                                <span>+50</span>
                            </div>
                        </div>
                        <div className={styles.task_item_right}>
                            <div className={styles.to_complete_btn}>
                                去完成
                            </div>
                        </div>
                    </div>
                </div>
                <div className={styles.task_item}>
                    <div className={styles.task_item_left}>
                        <img src={complete_personal_info} alt="" />
                    </div>
                    <div className={styles.task_item_middle}>
                        <div className={styles.task_item_middle_l}>
                            <div className={styles.task_item_middle_top}>补充个人信息</div>
                            <div className={styles.task_item_middle_bottom}>
                                <img src={point_icon} alt="" />
                                <span>+100</span>
                            </div>
                        </div>
                        <div className={styles.task_item_right}>
                            <div className={styles.completed_btn}>
                                去完成
                            </div>
                        </div>
                    </div>
                </div>
            </div> */}
            {
                freshmanTask && freshmanTask.length > 0 &&
                <div className={`${styles.task} ${styles.task_gap}`}>
                <div className={styles.title}>
                    新手任务
                </div>
                {
                    freshmanTask && freshmanTask.map((val: any, key: number) => (
                        <div className={styles.task_item} key={key}>
                            <div className={styles.task_item_left}>
                                <img src={freshmanImgRender(val)} alt="" />
                            </div>
                            <div className={`${styles.task_item_middle} ${(key + 1) != freshmanTask.length ? styles.task_item_bottom_line : ''}`}>
                                <div className={styles.task_item_middle_l}>
                                    <div className={styles.task_item_middle_top}>{val.name}</div>
                                    <div className={styles.task_item_middle_bottom}>
                                        <img src={point_icon} alt="" />
                                        <span>+{val.integral}</span>
                                    </div>
                                </div>
                                <div className={styles.task_item_right}>
                                    <div className={`${ val.state == 3 ? styles.completed_btn : styles.to_complete_btn}`} onClick={() => { toComplete(val)}}>
                                    {
                                            val.state == 3 ? 
                                            '已完成' :
                                            val.state == 2 ? 
                                            '领取奖励' :
                                            '去完成'
                                    }
                                    </div>
                                </div>
                            </div>
                        </div>
                    ))
                }
                {/* <div className={styles.task_item}>
                    <div className={styles.task_item_left}>
                        <img src={daily_share} alt="" />
                    </div>
                    <div className={styles.task_item_middle}>
                        <div className={styles.task_item_middle_l}>
                            <div className={styles.task_item_middle_top}>每日分享</div>
                            <div className={styles.task_item_middle_bottom}>
                                <img src={point_icon} alt="" />
                                <span>+20</span>
                            </div>
                        </div>
                        <div className={styles.task_item_right}>
                            <div className={styles.to_complete_btn}>
                                去完成
                            </div>
                        </div>
                    </div>
                </div>
                <div className={styles.task_item}>
                    <div className={styles.task_item_left}>
                        <img src={daily_test_task} alt="" />
                    </div>
                    <div className={styles.task_item_middle}>
                        <div className={styles.task_item_middle_l}>
                            <div className={styles.task_item_middle_top}>每日自测任务</div>
                            <div className={styles.task_item_middle_bottom}>
                                <img src={point_icon} alt="" />
                                <span>+200</span>
                            </div>
                        </div>
                        <div className={styles.task_item_right}>
                            <div className={styles.to_complete_btn}>
                                去完成
                            </div>
                        </div>
                    </div>
                </div>
                <div className={styles.task_item}>
                    <div className={styles.task_item_left}>
                        <img src={evalution_report} alt="" />
                    </div>
                    <div className={styles.task_item_middle}>
                        <div className={styles.task_item_middle_l}>
                            <div className={styles.task_item_middle_top}>AE评测报告</div>
                            <div className={styles.task_item_middle_bottom}>
                                <img src={point_icon} alt="" />
                                <span>+100</span>
                            </div>
                        </div>
                        <div className={styles.task_item_right}>
                            <div className={styles.to_complete_btn}>
                                去完成
                            </div>
                        </div>
                    </div>
                </div>
                <div className={styles.task_item}>
                    <div className={styles.task_item_left}>
                        <img src={read_ae_article} alt="" />
                    </div>
                    <div className={styles.task_item_middle}>
                        <div className={styles.task_item_middle_l}>
                            <div className={styles.task_item_middle_top}>阅读AE文章</div>
                            <div className={styles.task_item_middle_bottom}>
                                <img src={point_icon} alt="" />
                                <span>+50</span>
                            </div>
                        </div>
                        <div className={styles.task_item_right}>
                            <div className={styles.to_complete_btn}>
                                去完成
                            </div>
                        </div>
                    </div>
                </div> */}
            </div>
            }
        <div className={styles.b_gap}></div>
        </div>
    )
}

export default withRouter(AePointsMall);